import * as yup from "yup";

export const updateAuditorSchema = yup.object().shape({
  firstName: yup.string(),
  lastName: yup.string(),
  emailAddress: yup.string().email("Invalid email"),
  secondEmailAddress: yup.string().email("Invalid email"),

  companyAffiliation: yup.string(),
  officePhone: yup
    .string()
    .matches(/^1-\d{3}-\d{3}-\d{4}$/, "Office phone number must be in the format 1-234-567-8900"),
  mobilePhone: yup
    .string()
    .matches(/^1-\d{3}-\d{3}-\d{4}$/, "Mobile phone number must be in the format 1-234-567-8900"),
  country: yup.object({
    name: yup.string(),
  }),
  city: yup.string(),
  state: yup.string(),
  training: yup.string(),
  dateOfCompletion: yup.object({
    startDate: yup
      .date()
      .test(
        "is-valid-date",
        "Start date must be a valid date",
        (value) => !isNaN(new Date(value).getTime())
      ),
  }),
  cv: yup.mixed(),
});
